<template>
  <div>
    <lk-modal
      v-model="ifShow"
      title="关联关系"
      width='800px'
      :closable='false'
      :mask-closable='false'
      :footer-hide='true'
    >
      <div style="position:relative">
      <div class="queryArea">
        <div class="con">
          <div class="inputStyle">
            <div style="width:120px">医保中心商品:</div>
            <lk-input placeholder='请输入' class="item" clearable v-model="goodsName"></lk-input>
          </div>
          <div class="inputStyle" v-if="goodsType2 === 1">
            <div style="width:80px">批准文号:</div>
            <lk-input placeholder='请输入' class="item" clearable v-model="approvalCode"></lk-input>
          </div>
        </div>
        <lk-button type='primary' @click="hadleSearch">查询</lk-button>
      </div>
      <div class="exhibitInfoArea">
        <span style="margin-right:6px" v-for="item in exhibitInfoRules" :key='item.title'>{{`${item.title}:${exhibitObj[item.key] ? exhibitObj[item.key] : ''}`}}</span>
      </div>
      <div class="tableArea">
        <lk-table :columns='currentColumns' :data='tableData' highlight-row @on-current-change='handleChange' border></lk-table>
      </div>
      <div class="pageArea">
        <lk-page
          :total="total"
          :page-size='size'
          show-total
          class="page-top"
          @on-change='handlePage'
          :current.sync="page"
        ></lk-page>
      </div>
      <div class="btnArea">
        <div>
          <lk-button type='primary' style='margin-right:16px' @click="connect">确认关联</lk-button>
          <lk-button style='margin-right:16px' @click="retreat">无匹配商品</lk-button>
          <lk-button @click="cancel">取消</lk-button>
        </div>
      </div>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import healthInsManage from '../../services/healthInsManage';
import utils from '../../libs/utils';

export default {
  name: 'connectModal',
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    goodsType2: {  
      type: Number,
      default: 1
    },
    columns: {
      type: Array,
      default: () => []
    },
    exhibitInfoRules: {
      type: Array,
      default: () => []
    },
    exhibitObj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      page: 1,
      size: 10,
      total: null,
      approvalCode: null,
      goodsName: null,
      ifShow: this.showModal,
      inputValue: '',
      tableData: [],
      currentColumns: [],
      drugColumns: [
        {
            title: '序号',
            type: 'index',
            minWidth: 110,
        },
        {
            title: '编码',
            key: 'medListCodg',
            minWidth: 110,
            tooltip: true,
        },
        {
            title: '中文名称',
            key: 'regName',
            minWidth: 110,
            tooltip: true,
        },
        {
            title: '规格',
            key: 'spec',
            minWidth: 110,
            tooltip: true,
        },
        {
            title: '批准文号',
            key: 'approvalCode',
            minWidth: 110,
            tooltip: true,
        },
        {
            title: '处方药标志',
            key: 'prescriptionTypeName',
            minWidth: 110,
            tooltip: true,
        },
        {
            title: '剂型',
            key: 'dosageForm',
            minWidth: 110,
            tooltip: true,
        },
        {
            title: '药品类别',
            key: 'type',
            minWidth: 110,
            tooltip: true,
        },
      ],
      equipmentColumns: [
        {
            title: '编码',
            key: 'medListCodg',
            minWidth: 110,
            tooltip: true,
        },
        {
            title: '耗材名称',
            key: 'goodsName',
            minWidth: 110,
            tooltip: true,
        },
        {
            title: '医疗器械唯一标识码',
            key: 'unionCode',
            minWidth: 110,
            tooltip: true,
        },
        {
            title: '医保通用名',
            key: 'generalName',
            minWidth: 110,
            tooltip: true,
        },
        {
            title: '产品型号',
            key: 'prodMol',
            minWidth: 110,
            tooltip: true,
        },
        {
            title: '规格',
            key: 'spec',
            minWidth: 110,
            tooltip: true,
        },
        {
            title: '耗材分类',
            key: 'classify',
            minWidth: 110,
            tooltip: true,
        },
        {
            title: '规格型号',
            key: 'specModel',
            minWidth: 110,
            tooltip: true,
        },
      ],
      chiDrugColumns: [
        {
            title: '编码',
            key: 'medListCodg',
            minWidth: 110,
            tooltip: true,
        },
        {
            title: '单味药名称',
            key: 'tcmherbName',
            minWidth: 110,
            tooltip: true,
        },
        {
            title: '单复方标志',
            key: 'cpndFlag',
            minWidth: 110,
            tooltip: true,
        },
        {
            title: '常规用法',
            key: 'cnvlUsed',
            minWidth: 110,
            tooltip: true,
        },
        {
            title: '品种',
            key: 'cat',
            minWidth: 110,
            tooltip: true,
        },
      ],
      tempRow: {},
    }
  },
  watch: {
    showModal(val) {
      this.ifShow = val;
      if (val) {
        this.hadleSearch();
        this.assign();
      }
    },
  },
  computed: {
    
  },
  methods: {
    cancel() {
      this.ifShow = false;
      this.$emit('change', false);
    },
    handlePage(p) {
      this.page = p;
      this.hadleSearch();
    },
    handleChange(row) {
      this.tempRow = row;
    },
    connect() {
      let param = {
        fixmedinsHilistId: this.exhibitObj.code,
        fixmedinsHilistName: this.exhibitObj.approvedName,
        medListCodg: this.tempRow.medListCodg || '',
        medGoodsName: this.tempRow.goodsName || '',
        goodsStoreId: this.exhibitObj.goodsStoreId,
        goodsType: this.exhibitObj.goodsType,
        id: this.exhibitObj.id,
        uploadType: this.exhibitObj.uploadType,
      }
      this.$Spin.show();
      healthInsManage.dirUpdate(param).then((res => {
        this.$Spin.hide();
        if (res.data.status === 200) {
          this.$Message.success('关联成功');
          this.$emit('update');
          this.ifShow = false,
          this.$emit('change', false);
        } else {
          this.$Message.error(res.data.error);
        }
      })).catch((err) => {
        this.$Spin.hide();
        utils.handleError(err);
      })
    },
    retreat() {
      let param = {
        fixmedinsHilistId: this.exhibitObj.code,
        fixmedinsHilistName: this.exhibitObj.approvedName,
        goodsStoreId: this.exhibitObj.goodsStoreId,
        goodsType: this.exhibitObj.goodsType,
        uploadType: this.exhibitObj.uploadType,
        id: this.exhibitObj.id,
      }
      this.$Spin.show();
      healthInsManage.dirUpdate(param).then((res => {
        this.$Spin.hide();
        if (res.data.status === 200) {
          this.$Message.success('标记为无匹配');
          this.$emit('update');
          this.ifShow = false,
          this.$emit('change', false);
        } else {
          this.$Message.error(res.data.error);
        }
      })).catch((err) => {
        this.$Spin.hide();
        utils.handleError(err);
      })
    },
    hadleSearch() {
      let param = {
        approvalCode: this.approvalCode,
        goodsName: this.goodsName,
        page: this.page,
        size: this.size,
        goodsType: this.goodsType2
      }
      this.$Spin.show();
      healthInsManage.insuranceDrugSearch(param).then((res) => {
        this.$Spin.hide();
        if (res.data.status === 200) {
          if (param.goodsType === 1) {
            let arr = ['是', '否'];
            res.data.data.list.forEach((item) => {
              if (item.prescriptionType) {
                item.prescriptionTypeName = arr[item.prescriptionType-1];
              }
            })
          }
          this.tableData = res.data.data.list;
          this.total = res.data.data.count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.$Spin.hide();
        utils.handleError(err);
      })
    },
    assign() {
      if (this.goodsType2 === 1) {
        this.currentColumns = this.drugColumns;
      } else if (this.goodsType2 === 2) {
        this.currentColumns = this.equipmentColumns;
      } else if (this.goodsType2 === 3) {
        this.currentColumns = this.chiDrugColumns;
      }
    }
  },
  created() {
    this.assign();
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.queryArea {
  display: flex;
  .con {
    display: flex;
  }
}
.exhibitInfoArea {
  margin-top: 16px;
}
.inputStyle {
    display: flex;
    align-items: center;
    margin-right: 16px;
  }
.tableArea {
  margin: 20px 0;
}
.pageArea {
  display: flex;
  flex-direction: row-reverse;
}
.btnArea {
  width: 100%;
  margin-top: 16px;
  display: flex;
  flex-direction: row-reverse;
}
</style>
